import React from 'react';
import styled from 'styled-components';

const SubWrapper = styled.div`
  white-space: normal;
  padding: ${({ padding }) => padding};
`;

const ModuleTitle = styled.div`
  font-family: Hind;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
`;

function ModuleWrapper({ children, title = '', padding = '0px 0px 24px' }) {
  return (
    <SubWrapper padding={padding}>
      {title && <ModuleTitle data-publi={`wrapper-title-${title}`}>{title}</ModuleTitle>}
      {children}
    </SubWrapper>
  );
}

export { ModuleWrapper };
